import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-picking-list-status',
  templateUrl: './picking-list-status.component.html',
  styleUrls: ['./picking-list-status.component.scss']
})
export class PickingListStatusComponent implements OnInit {
    @Input() pickingList!: any;
    @Input() event!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
